import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { ContestAndIncentiveDetailsServiceHandler } from './contest-and-incentive-details.service.handler';

@Injectable({
  providedIn: 'root',
})
export class ContestAndIncentiveDetailsService extends ContestAndIncentiveDetailsServiceHandler {
  constructor(http: HttpClient, settingService: SettingService) {
    super(http, settingService);
  }
}
